import { Flex, Image } from "@chakra-ui/react";
import { colors } from "@/theme/colors";

export const LOGO_TYPES = /^image\/(png|jpeg|webp)$/;
export const LOGO_MAX_MB = 2;

// Company logo in a fixed box, or a teal circular initial avatar as fallback.
export const CompanyAvatar = ({ name, logoUrl, size = 44 }) =>
  logoUrl ? (
    <Flex align="center" justify="center" h={`${size}px`} w={`${size}px`} borderRadius="10px" bg={colors.white}
      border="1px solid" borderColor={colors.border} overflow="hidden" flexShrink={0}>
      <Image src={logoUrl} alt={`${name} logo`} maxH={`${size - 8}px`} maxW={`${size - 8}px`} objectFit="contain" />
    </Flex>
  ) : (
    <Flex align="center" justify="center" h={`${size}px`} w={`${size}px`} borderRadius="full" bg={colors.teal}
      color="white" fontFamily="heading" fontWeight="600" fontSize={size > 52 ? "2xl" : "md"} flexShrink={0}>
      {(name || "?").charAt(0).toUpperCase()}
    </Flex>
  );

export const StatusPill = ({ archived, testId }) => (
  <Flex as="span" align="center" px="2.5" py="0.5" borderRadius="full" fontSize="xs" fontWeight="600"
    flexShrink={0} bg={archived ? "#ECECEC" : "#D7F0EC"} color={archived ? colors.textSecondary : "#0F6E56"}
    data-testid={testId}>
    {archived ? "Deactivated" : "Active"}
  </Flex>
);
